import { StateInterface } from "./types";

export default {
  loggedIn(state: StateInterface): boolean {
    return state.loggedIn;
  },
  loggedInString(state: StateInterface): string {
    return state.loggedIn ? "true" : "false";
  }
};
